import {
    ChannelCompareRequest,
    ChannelDataRegister,
    TableDataForChannelRequest,
    TableDataForChannelResponse,
    TableMode,
} from '../types/api/tableData/TableDataForChannel';
import axios, {AxiosResponse} from 'axios';
import {handleError, handleErrorArray} from './errorHandling';
import {serializeParam} from './SearchtermAPI';
import {StickyRowSumsChannelCompareRequest, StickyRowSumsRequest} from '../types/api/tableData/SumRowData';

type ExtractMapResponse = {
    data: Array<{
        kvs: Array<[string, TableDataForChannelResponse]>;
    }>;
};
type ExtractMapResult = {[key: string]: TableDataForChannelResponse};

export function tableDataForChannel(data: TableDataForChannelRequest): Promise<AxiosResponse<TableDataForChannelResponse[]>> {
    const {mode, ...queryParams} = data;
    const getUrlForMode = (tableMode: TableMode) => {
        switch (tableMode) {
            case 'searchterm':
                return 'getTableDataForSearchTerms';
            case 'product':
                return 'getTableDataForProducts';
            case 'campaign':
                return 'getTableDataForCampaigns';
            default:
                throw Error('Cannot get url for tableMode ' + tableMode);
        }
    };
    return axios.get(`tableData/${getUrlForMode(mode)}`, {params: queryParams}).catch(handleError('error:loadingTableDataFailed'));
}

export function tableDataForChannelComparison(data: ChannelCompareRequest): Promise<ChannelDataRegister[]> {
    const {mode, ...queryParams} = data;
    const method = mode === 'searchterm' ? `getChannelDifferencesTableDataForSearchTerms` : `getChannelDifferencesTableDataForProducts`;
    return axios
        .get(`tableData/${method}`, {params: queryParams, paramsSerializer: (params) => serializeParam(params)})
        .then(extractMap)
        .catch(handleErrorArray('error:loadingTableDataFailed'));
}

export function stickyRowSums(data: StickyRowSumsRequest): Promise<AxiosResponse<TableDataForChannelResponse[]>> {
    const {mode, ...queryParams} = data;
    return axios
        .get(`tableData/getStickyTableHeaderRowData/${mode}`, {
            params: queryParams,
        })
        .catch(handleError('error:loadingOfChannelSumsFailed'));
}

export function stickyRowSumsForChannelComparison(data: StickyRowSumsChannelCompareRequest): Promise<ChannelDataRegister[]> {
    const {mode, ...queryParams} = data;
    return axios
        .get(`tableData/getChannelDifferencesStickyTableHeaderRowData/${mode}`, {
            params: queryParams,
            paramsSerializer: (params) => serializeParam(params),
        })
        .then(extractMap)
        .catch(handleErrorArray('error:loadingOfChannelSumsFailed'));
}

export const extractMap = (response: ExtractMapResponse): ExtractMapResult[] =>
    response.data
        .map((m) => m.kvs)
        .map((kvs) =>
            kvs.reduce((m, [k, v]) => {
                m[k] = v;
                return m;
            }, {} as ExtractMapResult)
        );

export function lastActivityTimestamp(): Promise<AxiosResponse<number>> {
    return axios.get('tableData/getLastActivityTimestamp').catch(handleError('error:loadingOfLastActiveDateRangeFailed'));
}



// WEBPACK FOOTER //
// ./src/apis/TableAPI.ts